export const ShipmentStatus = {
  Draft: 1,
  Pending: 2,
  Completed: 3,
  Posted: 4,
  Assigned: 5,
  Delivered: 6,
  Incomplete: 7,
};

export const LoadStatus = {
  Active: 1,
  PickedUp: 2,
  Delivered: 3,
  Completed: 4,
  Incomplete: 5,
};

export const LoadStatusMap = {
  [LoadStatus.Active]: "Assigned to Driver",
  [LoadStatus.PickedUp]: "Picked Up",
  [LoadStatus.Delivered]: "Delivered",
  [LoadStatus.Completed]: "Completed",
  [LoadStatus.Incomplete]: "Incomplete",
};

export const TrackingStatus = {
  AssignedToDriver: 0,
  InTransit: 1,
  Delivered: 2,
};

export const LoadStatusToTrackingStatusMap = {
  [LoadStatus.Active]: TrackingStatus.AssignedToDriver,
  [LoadStatus.PickedUp]: TrackingStatus.InTransit,
  [LoadStatus.Delivered]: TrackingStatus.Delivered,
  [LoadStatus.Completed]: TrackingStatus.Delivered,
  [LoadStatus.Incomplete]: TrackingStatus.Delivered,
};

export const VehicleType = {
  Car: 1,
  Truck: 2,
  SUV: 3,
  Van: 4,
  Other: 5,
  ATV: 7,
  Motorcycle: 6,
};

export const VehicleTypeMap = {
  [VehicleType.Car]: "Car",
  [VehicleType.Truck]: "Truck",
  [VehicleType.SUV]: "SUV",
  [VehicleType.Van]: "Van",
  [VehicleType.Other]: "Other",
  [VehicleType.ATV]: "ATV/UTV",
  [VehicleType.Motorcycle]: "Motorcycle",
};

export const LoadTimeSlot = {
  EighthAmToTwelvePm: 1,
  TwelvePmToFourPm: 2,
  FourPmToEighthPm: 3,
};

export const LoadTimeSlotMap = {
  [LoadTimeSlot.EighthAmToTwelvePm]: "8:00 AM - 12:00 PM (estimated)",
  [LoadTimeSlot.TwelvePmToFourPm]: "12:00 PM - 4:00 PM (estimated)",
  [LoadTimeSlot.FourPmToEighthPm]: "4:00 PM - 8:00 PM (estimated)",
};

export const VehicleSize = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
  XL: 4,
  UNKNOWN: 5,
};

export const VehicleSizeMap = {
  [VehicleSize.SMALL]: "Small",
  [VehicleSize.MEDIUM]: "Medium",
  [VehicleSize.LARGE]: "Large",
  [VehicleSize.XL]: "XL",
  [VehicleSize.UNKNOWN]: "Unknown",
};

export const STATUS = {
  IDLE: 1,
  LOADING: 2,
  SUCCESS: 3,
  ERROR: 4,
};
